export const Field = ({ label, value, onChange, type = "text", testId }) => (
  <div>
    <label className="text-sm font-semibold text-stone-700">{label}</label>
    <input type={type} value={value ?? ""} onChange={onChange} data-testid={testId}
      className="mt-1 w-full min-h-[44px] px-3 rounded-lg border border-stone-300 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
  </div>
);
